import React from 'react';

const WeightLossSection = ({
  sidebarLinks,
  downloadBrochure,
  bannerData,
  featuredImage,
  introText,
  specializationTitle,
  specializationText,
  leftColumnImage,
  rightColumnContent,
  counters,
}) => {
  return (
    <div className="prt-row sidebar prt-sidebar-left clearfix">
      <div className="container">
        <div className="row">
          {/* Sidebar */}
          <div className="col-lg-4 widget-area sidebar-left prt-sticky-column res-991-pt-20">
            <div>
              {/* Navigation Menu */}
              <aside className="widget widget-nav-menu with-title">
                <ul>
                  {sidebarLinks.map((link, idx) => (
                    <li key={idx} className={link.active ? "active" : ""}>
                      <a href={link.href}>{link.label}</a>
                    </li>
                  ))}
                </ul>
              </aside>
              {/* Download Brochure Widget */}
              <aside className="widget widget-download with-title">
                <div>
                  <div className="download_block">
                    <div className="download_img_icon">
                      <img
                        className="img-fluid auto_size"
                        width="50"
                        height="50"
                        src={downloadBrochure.image}
                        alt={downloadBrochure.alt || "download-pdf-img"}
                      />
                    </div>
                    <div className="prt-file-title">
                      <h3>
                        <a rel="noopener" href={downloadBrochure.link}>{downloadBrochure.title}</a>
                      </h3>
                      <span>{downloadBrochure.subtitle}</span>
                    </div>
                  </div>
                </div>
              </aside>
              {/* Banner Widget */}
              <aside className="widget widget-banner with-title">
                <div className="prt-col-bgcolor-yes bg-base-dark col-bg-img-four prt-col-bgimage-yes prt-bg">
                  <div className="prt-col-wrapper-bg-layer prt-bg-layer bg-base-dark">
                    <div className="prt-col-wrapper-bg-layer-inner bg-base-dark"></div>
                  </div>
                  <div className="border-rad_0">
                    <div className="layer-content">
                      <div className="featured-content">
                        <div className="featured-title style1">
                          <h3>
                            {bannerData.titleLine1} <br />
                            <span className="text-base-skin section-title-subtext style1">
                              {bannerData.highlightText}
                            </span>{" "}
                            {bannerData.titleLine2}
                          </h3>
                        </div>
                        <div className="featured-desc d-flex align-items-center">
                          <div className="featured-icon">
                            <img
                              className="img-fluid auto_size"
                              width="40"
                              height="48"
                              src={bannerData.icon}
                              alt="img"
                            />
                          </div>
                          <div className="pl-20 res-375-pl-0">
                            <p className="featured-desc-call">
                               <span>
                                <a href={`tel:${bannerData.phone}`}> {bannerData.phone}</a>
                              </span>
                            </p>
                            <a className="text-base-white underline" href={`mailto:${bannerData.email}`}>
                              {bannerData.email}
                            </a>
                          </div>
                        </div>
                        <div className="mt-35">
                          <a
                            target="_blank" rel="noreferrer noopener" className="prt-btn btn-inline prt-btn-size-sm prt-icon-btn-left text-base-white prt-btn-color-transperent style2"
                            href={bannerData.buttonLink}
                          >
                            {bannerData.buttonText}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>
          {/* Main Content */}
          <div className="col-lg-8 content-area">
            <div className="prt-service-single-content-area">
              <div className="prt_fatured_image-wrapper mb-20 res-575-mb-20">
                <img
                  width="829"
                  height="420"
                  className="img-fluid"
                  src={featuredImage}
                  alt="single-img"
                />
              </div>
              <div className="prt-service-description">
                <div className="mb-40 res-991-mb-20">
                  <p>{introText}</p>
                </div>
                <h3>{specializationTitle}</h3>
                <p>{specializationText}</p>
                <div className="row mt-40 res-991-mt-20">
                  <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                    <div className="prt-bg prt-col-bgimage-yes col-bg-img-three z-index-2">
                      <div className="prt-col-wrapper-bg-layer prt-bg-layer"></div>
                      <div className="layer-content">    <img
                        className="img-fluid prt-equal-s-image w-100"
                        src={leftColumnImage}
                        alt="bg-image"
                      />   
                      </div>
                    </div>

                  </div>
                  <div className="col-xl-6 col-lg-12 col-md-12">
                    <div className="pt-10 pb-10 res-1199-mt-15">
                      <div className="layer-content d-flex flex-column justify-content-center">
                        <h3>{rightColumnContent.title}</h3>
                        <p className="mb-15">
                          {rightColumnContent.descriptionBefore}{" "}
                          <u className="fw-500 headingfont-color">
                            {rightColumnContent.highlightText}
                          </u>{" "}
                          {rightColumnContent.descriptionAfter}
                        </p>
                        <div className="row">
                          <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
                            <ul className="prt-list fs-18 prt-list-style-icon">
                              {rightColumnContent.list1 &&
                                rightColumnContent.list1.map((item, idx) => (
                                  <li key={idx}>
                                    <i className="fa fa-check"></i>
                                    <div className="prt-list-li-content">{item}</div>
                                  </li>
                                ))}
                            </ul>
                          </div>
                          <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
                            <ul className="prt-list fs-18 prt-list-style-icon">
                              {rightColumnContent.list2 &&
                                rightColumnContent.list2.map((item, idx) => (
                                  <li key={idx}>
                                    <i className="fa fa-check"></i>
                                    <div className="prt-list-li-content">{item}</div>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-45 res-1199-mt-10">
                  <h3>{rightColumnContent.subTitle}</h3>
                  <p className="mb-10">{rightColumnContent.subDescription}</p>
                  <div className="row">
                    <div className="col-lg-12">
                      {counters.map((counter, idx) => (
                        <div key={idx}>
                          <div className="row">
                            <div className="col-xl-3 col-lg-4 col-md-3 col-sm-4">
                              <div className="prt-fid inside style4">
                                <div className="prt-fid-contents">
                                  <h4 className="prt-fid-inner">
                                    <span className="numinate">{counter.value}</span>
                                    {counter.suffix && <span>{counter.suffix}</span>}
                                  </h4>
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-9 col-lg-8 col-md-9 col-sm-8">
                              <div className="prt-fid-title style4">
                                <h3>{counter.title}</h3>
                                <p>{counter.description}</p>
                              </div>
                            </div>
                          </div>
                          {idx === 0 && <div className="border-top"></div>}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Main Content */}
        </div>
      </div>
    </div>
  );
};

export default WeightLossSection;
